<div class="diamond-filling">
  <app-shine-animation></app-shine-animation>
</div>
<fa-icon [icon]="faGem" size="2x"></fa-icon>
